import { Flex, Pagination, Table, Text } from '@mantine/core';
import { useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import * as C from '../../../../../ui/common/CommonStyles';
import { cleanParams } from '../../../../../../shared/utils/cleanParams';

import { useGetAiAgentModelList } from '../../../../../../shared/apis/ai-agent/model/reactQueries';
import { IEquipmentModel } from '../../../../../../shared/apis/ai-agent/model/types';

interface IPropsModelList {
  companyId: string;
}
export default function ModelList(props: IPropsModelList) {
  const { companyId } = props;
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const searchWord = searchParams.get('keyword') || '';
  const page = searchParams.get('page') || '1';
  const size = searchParams.get('size') || '20';

  const sendData = useMemo(
    () => ({
      companyId: Number(companyId),
      model: searchWord,
      page: Number(page),
      size: Number(size),
    }),
    [companyId, searchWord, page, size],
  );

  const { data: models } = useGetAiAgentModelList(sendData);
  return (
    <div>
      <Flex justify="space-between">
        <Text fw="bold" py="md" size="md">
          기계모델
        </Text>
      </Flex>
      <Table>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>번호</Table.Th>
            <Table.Th>기계모델명</Table.Th>
            <Table.Th>연결된 디바이스 갯수</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {models?.result && models?.result?.length > 0 ? (
            models?.result?.map((model: IEquipmentModel, index: number) => (
              <Table.Tr key={model.modelId}>
                <Table.Td>{(Number(page) - 1) * Number(size) + (index + 1)}</Table.Td>
                <Table.Td>{model.assignedName ? `${model.assignedName}(${model.model})` : '미할당'}</Table.Td>
                <Table.Td>{model.equipmentCount}</Table.Td>
              </Table.Tr>
            ))
          ) : (
            <Table.Tr>
              <Table.Td colSpan={3} style={{ textAlign: 'center' }}>
                데이터가 없습니다.
              </Table.Td>
            </Table.Tr>
          )}
        </Table.Tbody>
      </Table>
      <C.PaginationBox>
        <Pagination
          value={Number(page)}
          total={Math.ceil(Number(models?.count) / Number(size))}
          onChange={(value: number) => {
            const currentParams = Object.fromEntries(searchParams.entries());
            setSearchParams(
              cleanParams({
                ...currentParams,
                page: String(value),
              }),
            );
          }}
        />
      </C.PaginationBox>
    </div>
  );
}
